/**
 * @file 基本布局
 * @author hanzhichen(hanzhichen@baijia.com)
 * @date 2020-12-17
 */

import {useEffect} from 'react';
import {connect} from 'react-redux';
import {NavBar} from 'lark-mobile';
import PropTypes from 'prop-types';
import nvaBarLogo from '@/public/assets/gaotu-logo-h5.png';
import agentModel from '~/model/agent';
import './index.less';

/**
 * 活动开始时间
 * start:2025年1月1日00:00:00
 * 1735660800000
 * end:2025年1月17日23:59:59
 * 1757692799000
*/
const time = {
    start: 1768205135944,
    end: 1772553599000
};

const BasicLayout = props => {
    const {children, layout, agent: {isMobile}, location: {pathname}, dispatch} = props;
    useEffect(() => {
        // queryloginState
        document.title = '单点登录 | 高途集团';
        // 判断是否渲染移动端
        dispatch(agentModel.updateIsMobile());
    }, [dispatch]);

    const isLoginOrLogout = pathname === '/cas/login' || pathname === '/cas/logout';

    if (isLoginOrLogout && !layout.shouldRender) {
        return (
            <div>
                { children }
            </div>
        );
    }

    return (
        isMobile
            ? (
                <div className="h5-basic-layout">
                    <NavBar
                        leftContent={<img className="navbar-logo" src={nvaBarLogo} alt="高途集团" />
                        }
                        // rightContent={[<Icon key="0" type="menu" class="navbar-menu" />]}
                        class="navbar"
                    />
                    <div className="children-wrapper">
                        {children}
                    </div>
                </div>
            )
            : (
                <div className={
                    // eslint-disable-next-line max-len
                    new Date().getTime() >= time.start && new Date().getTime() <= time.end ? 'web-basic-layout-anniversary' : (new Date().getHours() >= 5 && new Date().getHours() < 17 ? 'web-basic-layout-day' : 'web-basic-layout-night')
                }
                >
                    {children}
                </div>
            )

    );
};


BasicLayout.defaultProps = {
    location: void 0
};

BasicLayout.propTypes = {
    children: PropTypes.node.isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }),
    layout: PropTypes.shape({
        shouldRender: PropTypes.bool.isRequired
    }).isRequired,
    agent: PropTypes.shape({
        isMobile: PropTypes.bool.isRequired
    }).isRequired,
    dispatch: PropTypes.func.isRequired
};

export default connect(({layout, agent}) => ({layout, agent}))(BasicLayout);
